const styles = {
  searchingText: {
    width: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  notifyText: {
    wordBreak: "break-all",
    fontSize: 14,
    color: "text.secondary",
  },
  excludedContainer: {
    p: 4,
    px: { xs: 2, lg: 20 },
    textAlign: "center",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    maxWidth: 420,
    mx: "auto",
    mt: 4,
    mb: 2,
    gap: 1.5,
  },
  emptyStateIcon: {
    fontSize: 26,
    color: "text.disabled",
  },
  emptyStateText: {
    fontSize: 14,
    color: "text.secondary",
    lineHeight: 1.5,
  },
};

export default styles;
